import WIDGETS from './widgets';

export default {
	name: 'booking_calendar',
	spacing: 2,
	sx: { width: '100%' },
	widgets: [{ content: WIDGETS.BOOKING_CALENDAR, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 }],
};
